import React from "react";
import RotationSchedulerPage from "./RotationSchedulerPage";

const DailySchedulePage = () => {
  return (
    <RotationSchedulerPage initialTab="daily-schedule" singleTabMode={true} />
  );
};

export default DailySchedulePage;

